// extracted by mini-css-extract-plugin
export default {"videoContainer":"Video_videoContainer__21-v6","iframe":"Video_iframe__G6DYH","video":"Video_video__3i9DM"};